module.exports = __webpack_public_path__ + "media/images/vp/icon.phone.red-d4fb5b41b025d7428e1911607a1e7308.svg";